import request from '@/router/axios'
import env from '@/config/env'

// 获取分页
export const pageApi = (params) => {
  return request({
    url: env.officeUrl + '/company/page',
    method: 'POST',
    data: params
  })
}
// 获取枚举
export const state = (params) => {
  return request({
    url: env.officeUrl + '/company/enum',
    method: 'get',
    params
  })
}
// 保存公司信息
export const saveCompany = (params) => {
  return request({
    url: env.officeUrl + '/company/save',
    method: 'post',
    data: params
  })
}
// 获取公司信息
export const detail = (params) => {
  return request({
    url: env.officeUrl + '/company/detail',
    method: 'get',
    params
  })
}
// 获取公司配置
export const configList = (params) => {
  return request({
    url: env.officeUrl + '/company/config/list',
    method: 'post',
    params
  })
}
// 删除公司配置
export const configDel = (params) => {
  return request({
    url: env.officeUrl + '/company/config/del',
    method: 'delete',
    params
  })
}
// 保存公司配置
export const configSave = (type, params) => {
  return request({
    url: env.officeUrl + '/company/config/save?type=' + type,
    method: 'post',
    data: params
  })
}
// 获取获取日志分页
export const logPage = (params) => {
  return request({
    url: env.officeUrl + '/log/page',
    method: 'post',
    data: params
  })
}
